import React, { FC } from 'react'
import { AbilityContext, defineAbilityForRole } from 'shared/abilities'
import { useCurrentUser } from 'modules/User/useCurrentUser'
import { Spinner } from 'components/Spinner/Spinner'
import { Button } from '@wmgtech/legato'
import { useOktaAuth } from '@okta/okta-react'
import { Errors } from 'pages/Errors'

export const AuthorizationProvider: FC = ({ children }) => {
  const { oktaAuth } = useOktaAuth()
  const { user, loading, error } = useCurrentUser()

  if (loading) return <Spinner />
  if (error) {
    return <Errors.Unauthorized
      showActionButtons={false}
      title={error.name}
      description={error.message}
    >
      <Button
        size="lg"
        style={{ margin: '20px auto 0', display: 'block' }}
        onClick={() => oktaAuth.signOut()}
      >
        Sign Out
      </Button>
    </Errors.Unauthorized>
  }

  return user ? (
    <AbilityContext.Provider value={defineAbilityForRole(user)}>
      {children}
    </AbilityContext.Provider>
  ) : null
}
